const routes=[
    {
        id:1,
        img:"img/p7.jpg",
        place:"Khumai",
        text:"20.7km from Pokhara"
    }
    ,
    {
        id:2,
        img:"img/p8.jpg",
        place:"Mardi",
        text:"31km from Pokhara"
    }
    ,
    {
        id:3,
        img:"img/p9.jpeg",
        place:"Gosainkunda",
        text:"44km from Kathmandu"
    }
    ,
    {
        id:4,
        img:"img/p10.jpg",
        place:"Sauraha",
        text:"14km from Chitwan"
    }
    ,
    {
        id:5,
        img:"img/p11_panchpokhari.jpg",
        place:"Panchpokhari",
        text:"53km from Kathmandu"
    }
    ,
    {
        id:6,
        img:"img/p12_shiva.jpg",
        place:"Shiva Statue",
        text:"5km from Pokhara"
    }
]


export default routes;